import { Component, effect, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-naps-input-box',
  standalone:true,
  imports:[ReactiveFormsModule,NgbModule],
  templateUrl: './nsdc-input-box.component.html',
  styleUrl: './nsdc-input-box.component.scss'
})
export class NsdcInputBoxComponent {
customFormControl = input<FormControl>(new FormControl(''));
customValue = input<string|undefined>(undefined);
label = input<string>('');
rightLabel = input<string|undefined>(undefined);
underLinedRightLabel = input<boolean>(false);
disableRightLabel = input<boolean>(false);
rightLabelButtonClicked = output<string>();
infoMessage = input<string|undefined>(undefined);
placeholder = input<string>('');
isRequired = input<boolean>(false);
errorMessage = input<string>('');
inputType = input<'text'|'number'|'email'|'textArea'>('text');
ariaLabel = input<string>('');
height = input<string>("40");
disabledField=input<boolean>(false);
preventDrop = input<boolean>(false);
preventDrag = input<boolean>(false);
preventPaste = input<boolean>(false);
customKeyUp = output<string>();
customKeyPress = output<string>();
customChange = output<string>();
customBlur = output<string>();
customMinLength=input<number>(0);
customMaxLength=input<number|undefined>(undefined);
applyOnlyNumbers = input<boolean>(false);
isAppUpperCase = input<boolean>(false);
isMasked = input<boolean>(false);
maskPattern = input<any>();
isReadOnly = input<boolean>(false);

constructor() {
  effect(() => {
    const control = this.customFormControl();
    if (!control) return;

    if (this.disabledField()) {
      control.disable({ emitEvent: false });
    } else {
      control.enable({ emitEvent: false });
    }
  });
}

preventDefault(event:Event){
event.preventDefault();
}

}
